<template>
    <div id="Login" class="starter-template">
        <b-container>
            <br>
            <b-row>
                <b-col lg="3"></b-col>
                <b-col lg="6">
                    <b-card no-body class="overflow-hidden mb-2 itsBkg">
                        <b-row no-gutters>
                            <b-col lg="6">
                                <b-card-img src="data/imgs/sign_in.png" alt="Image" class="rounded-0"></b-card-img>
                            </b-col>
                            <b-col md="6">
                                <b-card-body>
                                    <b-card-text>
                                        {{this.$t('LOGIN')}}

                                            <b-form-group id="ex-gr1">
                                                <b-form-input
                                                    id="ex1"
                                                    v-model.trim="$v.form.userName.$model"
                                                    :state="validateState('userName')"
                                                    aria-described-by="input-1"
                                                ></b-form-input>
                                                <b-form-invalid-feedback
                                                    id="input-1"
                                                >{{this.$t('R_NAME')}}
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                            {{this.$t('PWD')}}
                                            <b-form-group id="ex-gr2" label-for="ex2">
                                                <b-form-input
                                                    id="ex2"
                                                    type="password"
                                                    v-model.trim="$v.form.pwd.$model"
                                                    :state="validateState('pwd')"
                                                    aria-described-by="input-2"
                                                ></b-form-input>
                                                <b-form-invalid-feedback
                                                    id="input-2"
                                                >{{this.$t('R_PWD')}}
                                                </b-form-invalid-feedback>
                                            </b-form-group>

                                        <br>
                                    </b-card-text>
                                    <b-button href="#" variant="primary" @click="onSubmit()">{{this.$t('ENTER')}}</b-button>
                                </b-card-body>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>
                <b-col lg="3"></b-col>
<!---
<b-col lg="6">
<b-card no-body class="overflow-hidden mb-2 itsBkg" style="min-height:16em">
<b-row no-gutters>
    <b-col md="6">
        <b-card-body>
            <b-card-text>
                <br>
                <br><br>

                <a href="https://www.itsmap.ru/facebook"><b-img :src="fbImg" key=:key></b-img></a>
                <br><br><br>
                <a href="/oidc"><b-img :src="googleImg"></b-img></a>

            </b-card-text>
        </b-card-body>
    </b-col>
    <b-col md="6">
        <b-card-img src="data/imgs/snl.png" alt="Image" class="rounded-0"></b-card-img>
    </b-col>

</b-row>
</b-card>
</b-col>
-->

</b-row>


            <br>
            <b-row>
                <b-col lg="6">
                    <b-card no-body class="overflow-hidden mb-2 itsBkg">
                        <b-row no-gutters>
                            <b-col md="5">
                                <b-card-img src="data/imgs/register.png" alt="Image" class="rounded-0"></b-card-img>
                            </b-col>
                            <b-col md="7">
                                <b-card-body>
                                    <b-card-text>
                                        <br><br>
                                    </b-card-text>
                                    <b-button href="#" variant="primary" @click="createUser()">{{this.$t('REG')}}</b-button>
                                </b-card-body>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>
                <b-col lg="6">
                    <b-card no-body class="overflow-hidden  mb-2 itsBkg">
                        <b-row no-gutters>
                            <b-col md="5">
                                <b-card-body>
                                    <b-card-text>
                                        <br><br>
                                    </b-card-text>
                                    <b-button href="#" variant="primary" @click="askRem=true">{{this.$t('REM')}}</b-button>
                                    <br><br>
                                </b-card-body>
                            </b-col>
                            <b-col md="7">
                                <b-card-img src="data/imgs/rem.png" alt="Image" class="rounded-0" style="margin-top:2em"></b-card-img>
                                <br><br><br>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>
            </b-row>

        </b-container>

        <CheckCode
           v-on:signIn="signIn"
           v-bind:userName="form.userName"
           v-if="askCode"
        />

        <Remind
           v-on:reminded="reminded"
           v-if="askRem"
        />

        <b-container fluid class="footer text-center">
            <b-button @click="$showDoc('About')">{{$t('ABOUT')}}</b-button>
            <b-button @click="$showDoc('Terms')" class="m-1">{{$t('TERMS')}}</b-button>
            <b-button @click="$showDoc('Privacy')">{{$t('PRIVACY')}}</b-button>
            <b-button class="m-1" @click.stop.prevent="showHelp=true"><font-awesome-icon icon="question" size="lg" :style="{ color: 'white' }" /></b-button>
        </b-container>

        <Help
                v-on:closeHelp="showHelp=false"
                v-bind:helpName="helpName"
                v-if="showHelp"
        />

    </div>
</template>

<script>
import { BRow, BCol, BContainer, BCard, BCardBody, BCardText, BCardImg, BButton, //BImg,
    BFormGroup, BFormInput, BFormInvalidFeedback} from 'bootstrap-vue';
import CheckCode from "./CheckCode.vue";
import Remind from "./Remind.vue";
import { validationMixin } from "vuelidate";
import { helpers, required, minLength, maxLength} from 'vuelidate/lib/validators';
import Help from "./Help.vue";
//const alpha = helpers.regex('alpha', /^[a-zA-Zа-яА-Я]*$/);
const itemNameR = helpers.regex('itemNameR',/^(?!.*?[-\s]{2})[a-zA-Z.\-а-яА-ЯёЁ\s]+$/);

export default {
  name: 'Login',
  components: {
      CheckCode, Remind, Help,
      BRow, BCol, BContainer, BCard, BCardBody, BCardText, BCardImg, BButton, BFormGroup, BFormInput, BFormInvalidFeedback // ,BImg
  },
  mixins: [validationMixin],
  data: function() {
    return {
      form: {
        userName: '',
        pwd: ''
      },
      userName: '',
      code: '',
      askCode: false,
      askRem: false,
      intLoc: this.$i18n.locale,
      fbImg: 'data/imgs/fb_log_'+this.$i18n.locale+'.jpg',
      googleImg: 'data/imgs/google_log_'+this.$i18n.locale+'.jpg',
      key: 0,
      helpName: 'HelpLogin',
      showHelp: false
    }
  },
  mounted() {
    let userName = this.userName = this.$store.state.curUserName;
    if(userName) {
        this.$router.push({
            path: '/Map/UserMap/'+'_/'+userName,
            query: { all: false }
        });
    }
    if(this.$route.query.del) this.showHelp=true;
  },
  methods: {
    validateState(name) {
        const { $dirty, $error } = this.$v.form[name];
        return $dirty ? !$error : null;
    },

    async onSubmit() {
        this.$v.form.$touch();
        if(this.$v.form.$anyError) return;
        let body = 'username='+this.form.userName+'&password='+this.form.pwd;
        try {
            const response = await this.$http.post('/callback?client_name=FormClient', body);
            let result = await response.data;
            this.userName = result.userName;
            if(result.confirmed==='true') {
                this.$store.commit('setCurUserName', result.userName);
                this.$incSession();
                if(result.userName==='admin')
                    this.$router.push({
                        path: '/UsersList',
                        query: {
                            published: true,
                            blocked: false
                        }
                     });
                else
                    this.$router.push({
                        path: '/Map/UserMap/'+'_/'+this.$addEncHyp(result.userName),
                        query: { all: false }
                    });
                }
            else {
                this.askCode = true;
                this.$store.commit('setCurUserName', '');
            }
         } catch(error) {
            if(typeof error.response === 'undefined') this.$serveErr('Login: onSubmit() '+error.message);
            else this.$showErr(error.response.data, error.response.status);
        }
    },

    signIn(checked) {
        this.askCode = false;
        if(!checked) {
            this.$store.commit('setCurUserName', '');
            return;
        }
        this.$store.commit('setCurUserName', this.userName);
        if(this.userName==='admin')
            this.$router.push({
                path: 'UsersList',
                query: {
                    published: true,
                    blocked: false
                }
            });
        else
            this.$router.push({
                path: '/Map/UserMap/'+'_/'+this.$addEncHyp(this.userName),
                query: { all: false }
            });
    },
    reminded(state) {
        this.askRem = false;
        if(state) this.$showMsg(this.$t('DATA_SENT'));
    },
    createUser() {
        this.$router.push({ path: 'CreateUser' });
    },
  },
  validations: {
    form: {
        userName: {
            required,
            //alpha,
            itemNameR,
            minLength: minLength(2),
            maxLength: maxLength(24)
        },
        pwd: {
            required,
            minLength: minLength(6),
            maxLength: maxLength(24)
        }
    }
  },
  watch: {
    '$store.state.intLoc': function() {
        this.intLoc = this.$store.state.intLoc;
        this.fbImg = 'data/imgs/fb_log_'+this.$i18n.locale+'.jpg';
        this.googleImg = 'data/imgs/google_log_'+this.$i18n.locale+'.jpg';
        this.key++;
    }
  }

}

</script>

<style>
</style>